const randomString = (maxLength) => 
// Simple pseudo-random string generator. The length of the output is limited
// by the precision of Math.random() and maxLength.
Math.random()
    .toString(36)
    .substring(2, maxLength);
const randomLetter = () => {
    const characters = 'abcdefghijklmnopqrstuvwxyz';
    const charactersArray = characters.split('');
    return charactersArray[Math.floor(Math.random() * charactersArray.length)];
};
/**
 * Takes a space delimited string, and converts it to an array of classes.
 * Also appending a constant baseClassname to the front of the class
 * @param dataTarget a component's dataVariant or dataType attribute
 * @param baseClassname a baseClassname set as a constant in the component
 * @returns an array of classnames that can be spread into the getClassnames method
 */
const createClassesFrom = (dataTarget, baseClassname = 'data-class') => {
    const passedTarget = dataTarget || ' ';
    const passedBaseclass = baseClassname;
    const newArray = passedTarget.split(' ');
    return newArray.map((element) => `${passedBaseclass}--${element}`);
};
const createDataAttributeArray = (inputString, namespace) => {
    if (!inputString) {
        return [];
    }
    const array = inputString.split(' ');
    if (namespace) {
        return array.map(item => `${namespace}--${item}`);
    }
    return array;
};
// we're enforcing IDs that start with a letter
// by inserting a random letter
const generateSimpleID = () => `${randomLetter()}${randomString(10)}`;
const sort = (valueA, valueB) => {
    if (valueA.match < valueB.match)
        return -1;
    if (valueA.match > valueB.match)
        return 1;
    return 0;
};
const getClassnames = (classArray) => classArray
    .filter(classname => !!classname)
    .join(' ')
    .trim();
const ratioToPercentage = (ratio) => {
    const [first, second] = ratio.split('/');
    return (parseInt(second, 10) / parseInt(first, 10)) * 100;
};
const functionQueue = [];
const inheritAttributes = (el, attributes = []) => {
    const attributeObject = {};
    attributes.forEach(attr => {
        if (el.hasAttribute(attr)) {
            const value = el.getAttribute(attr);
            if (value !== null) {
                attributeObject[attr] = el.getAttribute(attr);
            }
            el.removeAttribute(attr);
        }
    });
    return attributeObject;
};

export { generateSimpleID as a, createClassesFrom as b, createDataAttributeArray as c, functionQueue as f, getClassnames as g, inheritAttributes as i, ratioToPercentage as r, sort as s };

